<main class="canvas list-page">
  <div class="topbar">
    <div class="search">
      <mat-form-field>
        <mat-icon matPrefix class="listaus-haku-ikoni">search</mat-icon>
        <mat-label>{{ 'kuitit.etsi' | translate | async }}</mat-label>
        <input type="text" matInput readonly (click)="avaaHaku()" style="cursor: pointer" [attr.aria-label]="'tositteet.avaa-haku' | translate | async" />
      </mat-form-field>
    </div>

    <button type="button" mat-button class="primarybutton mat-elevation-z4" [routerLink]="['/tositteet/osto/lisaa']">
      <mat-icon>cloud_upload</mat-icon>
      {{ 'tositteet.osto.listaus.lisaa' | translate | async }}
    </button>
  </div>

  <app-kuukausi-valinta [otsikko]="otsikkoObservable | async" [valittuKuukausi]="valittuKuukausiObservable | async" [edellisenKkSelvitettavat]="edellisenKuukaudenSelvitettavat()" [seuraavanKkSelvitettavat]="seuraavanKuukaudenSelvitettavat()" (edellinenKk)="edellinenKuukausi()" (seuraavaKk)="seuraavaKuukausi()" (kuukausiValittu)="valitseKuukausi($event)"> </app-kuukausi-valinta>

  <div class="maksutapa-valinta" [class.raahataan]="raahataan()" role="group" [attr.aria-label]="'kuitit.rajaa-maksutavalla' | translate | async">
    <button type="button" class="maksutapa-pilleri" [class.maksutapa-pilleri-valittu]="valittuMaksutapa() === null" [attr.aria-pressed]="valittuMaksutapa() === null" (click)="valitseMaksutapa(null)">
      <span class="maksutapa-ikoni" aria-hidden="true"><span class="material-symbols-outlined maksutapa-ikoni-symboli">grid_view</span></span>
      <span class="maksutapa-nimi" [attr.data-teksti]="'kuitit.maksutapa-kaikki' | translate | async">{{ 'kuitit.maksutapa-kaikki' | translate | async }}</span>
      <span class="maksutapa-maara" [attr.data-teksti]="kaikkienLukumaara()">{{ kaikkienLukumaara() }}</span>
    </button>
    @for (valinta of maksutapaValinnat(); track valinta.tunniste) {
      <button
        type="button"
        class="maksutapa-pilleri"
        [class.maksutapa-pilleri-valittu]="naytetaankoValittuna(valinta)"
        [class.maksutapa-pilleri-pudotettava]="valinta.voiPudottaa"
        [attr.aria-pressed]="valittuMaksutapa() === valinta.tunniste"
        (click)="valitseMaksutapa(valinta.tunniste)"
        (dragover)="kasitteleRaahausMaksutavanYli($event, valinta)"
        (dragleave)="kasitteleRaahausPoisMaksutavalta(valinta)"
        (drop)="kasittelePudotusMaksutavalle($event, valinta)"
      >
        <span class="maksutapa-ikoni" aria-hidden="true">
          @if (valinta.kuva) {
            <img class="maksutapa-ikoni-kuva" [src]="valinta.kuva" alt="" />
          }
        </span>
        <span class="maksutapa-nimi" [attr.data-teksti]="valinta.nimi">{{ valinta.nimi }}</span>
        <span class="maksutapa-maara" [attr.data-teksti]="valinta.lukumaara">{{ valinta.lukumaara }}</span>
      </button>
    }
  </div>

  <div class="total">
    <div>
      <div class="total-amount">{{ kuukaudenYhteissumma() }}</div>
      <div class="total-meta">
        {{ 'kuitit.yhteensa' | translate | async }} {{ tositteidenKokonaismaara }}
        {{ tositteidenKokonaismaara === 1 ? ('kuitit.tosite' | translate | async) : ('kuitit.tositetta' | translate | async) }}
      </div>
    </div>

    <div class="esitystapa-valinta" role="group" [attr.aria-label]="'tositteet.esitystapa' | translate | async">
      <button type="button" class="esitystapa-painike" [class.esitystapa-painike-valittu]="esitystapa === 'tiivis'" [attr.aria-pressed]="esitystapa === 'tiivis'" [attr.aria-label]="'tositteet.esitystapa-tiivis' | translate | async" [attr.title]="'tositteet.esitystapa-tiivis' | translate | async" (click)="vaihdaEsitystapa('tiivis')">
        <span class="material-symbols-outlined" aria-hidden="true">view_headline</span>
      </button>
      <button type="button" class="esitystapa-painike" [class.esitystapa-painike-valittu]="esitystapa === 'kuvilla'" [attr.aria-pressed]="esitystapa === 'kuvilla'" [attr.aria-label]="'tositteet.esitystapa-kuvilla' | translate | async" [attr.title]="'tositteet.esitystapa-kuvilla' | translate | async" (click)="vaihdaEsitystapa('kuvilla')">
        <span class="material-symbols-outlined" aria-hidden="true">photo_library</span>
      </button>
      <button type="button" class="esitystapa-painike" [class.esitystapa-painike-valittu]="esitystapa === 'kortit'" [attr.aria-pressed]="esitystapa === 'kortit'" [attr.aria-label]="'tositteet.esitystapa-kortit' | translate | async" [attr.title]="'tositteet.esitystapa-kortit' | translate | async" (click)="vaihdaEsitystapa('kortit')">
        <span class="material-symbols-outlined" aria-hidden="true">grid_view</span>
      </button>
    </div>
  </div>

  @if (selvitysniput().length > 0) {
    <div class="section-head section-head-alert">
      <span class="section-head-title">{{ 'kuitit.selvitettavat' | translate | async }}</span>
      <span class="section-head-count">{{ selvityspyynnot().length }}</span>
    </div>

    <div class="resolve-niput">
      @for (nippu of selvitysniput(); track nippu.tyyppi) {
        <div class="resolve-nippu" [class.resolve-nippu-avattu]="nippu.auki">
          @if (nippu.auki) {
            <button type="button" class="niputa-button" (click)="niputaSelvitettavat(nippu.tyyppi)">
              <span class="material-symbols-outlined niputa-icon" aria-hidden="true">keyboard_arrow_up</span>
              {{ 'kuitit.nippu-niputa' | translate | async }}
            </button>
          }
          @for (kortti of nippu.naytettavat; track kortti.avain) {
            <div class="huomio-kortti">
              <app-selvitys-kortti [kortti]="kortti" [yritysmuoto]="yritysmuoto"></app-selvitys-kortti>
              <span class="huomio-badge" aria-hidden="true">
                @if (!nippu.auki && nippu.kortit.length > 1) {
                  {{ nippu.kortit.length }}
                }
              </span>
            </div>
          }
          @if (!nippu.auki && nippu.kortit.length > 1) {
            <button type="button" class="nayta-kaikki-button" (click)="avaaSelvitysnippu(nippu.tyyppi)">{{ 'kuitit.nippu-nayta-kaikki' | translate: { maara: nippu.kortit.length } | async }}</button>
          }
        </div>
      }
    </div>
  }

  <app-tosite-lista [rivit]="tositteet()" [esitystapa]="esitystapa" [projektitMap]="projektitMap()" [nykyinenSorttaus]="nykyinenSorttaus" (riviKlikattu)="avaaTosite($event)" (sorttausMuuttui)="sorttausMuuttui($event)"></app-tosite-lista>

  @if ((datasourceService.rivienMaaraObservable | async) > 20) {
    <mat-paginator #paginator [length]="datasourceService.rivienMaaraObservable | async" [pageSize]="datasourceService.page?.pageSize" [pageIndex]="datasourceService.page?.pageIndex" [pageSizeOptions]="[20, 50, 200]" (page)="sivunvaihto($event)"> </mat-paginator>
  }
</main>

<app-tosite-haku [avoinna]="hakuAvoinna" (suljettu)="suljeHaku()"></app-tosite-haku>
